import styled from 'styled-components'

export const CourtImageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const CourtDefault = styled.div`
  width: 250px;
  height: 250px;
  border-radius: 15px;
  background: #f5f5f5;
`
export const CourtPhoto = styled.img`
  width: 250px;
  border-radius: 15px;
  background: #f5f5f5;
  object-fit: cover;
`
